import React, { FC, useCallback } from 'react';
import { useSelector, useStore } from 'react-redux';
import { MenuButton } from 'ui';
import { toggleHeatMap } from '../actions/homeHeatMap';
import { HomeState } from '../store/homeState';

/**
 * HomeHeatMap custom hook.
 */
const useHeatMap = () => {
  const { dispatch, getState } = useStore<HomeState>();

  const isHeatMap = useSelector((state: HomeState) => state.isHeatMap);

  return { dispatch, getState, isHeatMap };
};

/**
 * Heat map button.
 */
export const HomeHeatMap: FC = () => {
  const { dispatch, getState, isHeatMap } = useHeatMap();

  const onClick = useCallback(() => {
    toggleHeatMap(dispatch, getState, !isHeatMap);
  }, [dispatch, getState, isHeatMap]);

  return <MenuButton text="Heat Map" isSelected={isHeatMap} onClick={onClick} />;
};
